const estilo_coluna_fixo = {
  backgroundColor: 'white',
  position: 'sticky !important',
  zIndex: '1 !important',
}

export const cabecalhos = [
  {
    text: 'Id Grupo',
    value: 'idgrupo',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Descrição do grupo',
    value: 'descricao_grupo',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Descrição do segmento',
    value: 'descricao_segmento',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Descrição do fornecedor',
    value: 'descricao_fornecedor',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Id produto',
    value: 'idproduto',
    string: true,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '100px',
      maxWidth: '100px',
      right: 'auto',
      left: 0,
      zIndex: 1,
    }
  },
  {
    text: 'Descrição do produto',
    value: 'descricao_produto',
    string: true,
    style: {
      ...estilo_coluna_fixo,
      minWidth: '180px',
      maxWidth: '180px',
      right: 'auto',
      left: '100px',
      zIndex: 1,
      borderRight: '2px solid rgba(0,0,0,.1)',
    }
  },
  {
    text: 'Data de cadastro',
    value: 'data_cadastro',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Idade',
    value: 'idade',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Preço médio de custo',
    value: 'preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Preço médio de venda',
    value: 'preco_venda',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque (R$ de custo)',
    value: 'estoque_em_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Markup',
    value: 'markup',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque (R$ de venda)',
    value: 'estoque_em_preco_venda',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Cobertura Instantânea',
    value: 'cobertura_estoque',
    numero: true,
    append: 'dias',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Análise cobertura',
    value: 'grupo_intervalo_cobertura',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Data cobertura instantânea',
    value: 'data_cobertura_instatanea',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque',
    value: 'estoque',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque de segurança',
    value: 'esseg',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Ponto de pedido',
    value: 'pp',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'EMáx Systock',
    value: 'emax',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'EMáx Systock (R$ de custo)',
    value: 'emax_em_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Cobertura EMáx Systock',
    value: 'cobertura_emax',
    numero: true,
    append: 'dias',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Status do estoque',
    value: 'status_produto',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Excesso Atual (Dif entre Estoque – EMáx Systock)',
    value: 'estoque_em_excesso',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Excesso Atual (R$ de custo)',
    value: 'estoque_em_excesso_em_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Projeção de vendas',
    value: 'consumo_medio_mensal',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Projeção de Vendas (R$ de custo)"',
    value: 'cmm_em_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Projeção de Vendas (R$ de vendas)',
    value: 'cmm_em_preco_venda',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Faturamento',
    value: 'faturamento',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Data da última saída',
    value: 'data_ult_saida',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Dias sem venda',
    value: 'qtde_dias_sem_vender',
    numero: true,
    append: 'dias',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Histograma',
    value: 'histograma',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Classificacao financeira',
    value: 'classificacao_financeira',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Classificacao de popularidade',
    value: 'classificacao_popularidade',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Classificacao de comprabilidade',
    value: 'classificacao_comprabilidade',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Classificacao de criticidade',
    value: 'classificacao_criticidade',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Nível de serviço',
    value: 'nivel_servico',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Frequência média de apanhe',
    value: 'tempo_medio_apanhe',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Frequência de saída',
    value: 'frequencia_saida',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Ativo para Venda',
    value: 'ativo_para_venda',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Fora de linha',
    value: 'fora_de_linha',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Tempo Médio de Ressuprimento',
    value: 'tempo_ressuprimento_dias',
    numero: true,
    append: 'dias',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Id pedido em trânsito',
    value: 'id_solicitacao',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Data de solicitação',
    value: 'data_solicitacao',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque em trânsito',
    value: 'estoque_transito',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Data prevista para entrega',
    value: 'data_previsao',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Status da Demanda',
    value: 'status_demanda',
    string: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Demanda Possível',
    value: 'demanda_real',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Demanda Possível (R$ de vendas)',
    value: 'faturamento_real',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Dif entre Projeção de vendas - Demanda Possível (R$ de vendas)',
    value: 'diferenca',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Cobertura EMáx Parametrizável',
    value: 'cobertura_parametrizavel',
    numero: true,
    append: 'dias',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'EMáx Parametrizável',
    value: 'emax_parametrizavel',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'EMáx Parametrizável (R$ de custo)',
    value: 'estoque_parametrizavel_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Estoque a Aumentar (Dif entre EMáx Parametrizável - Estoque)',
    value: 'total_estoque_para_aumentar',
    numero: true,
    style: {
      minWidth: '360px',
      background: '#e6ffe5 !important',
    }
  },
  {
    text: 'Estoque a Aumentar (R$ de custo)',
    value: 'total_estoque_para_aumentar_preco_custo',
    dinheiro: true,
    style: {
      ...estilo_coluna_fixo,
      right: '200px',
      left: 'auto',
      zIndex: 0,
      minWidth: '210px',
      background: '#e6ffe5 !important',
    }
  },
  {
    text: 'Estoque a Diminuir (Dif entre Estoque - EMáx Parametrizável)',
    value: 'total_estoque_para_reduzir',
    numero: true,
    style: {
      minWidth: '350px',
      left: 'auto',
      background: '#fdebeb !important',
    }
  },
  {
    text: 'Estoque a Diminuir (R$ de custo)',
    value: 'total_estoque_para_reduzir_preco_custo',
    dinheiro: true,
    style: {
      ...estilo_coluna_fixo,
      right: 0,
      zIndex: 0,
      minWidth: '200px',
      background: '#fdebeb !important',
    }
  },
  {
    text: 'Sugestão de compras',
    value: 'sugestao_compra',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Total a comprar',
    value: 'sugestao_compra_preco_custo',
    dinheiro: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Saldo futuro',
    value: 'estoque_futuro_preco_custo',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Necessidade de Distribuição',
    value: 'precisa_distribuir',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Possui transferência separada',
    value: 'possui_pedido_em_separacao',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Qtde. pedidos em transferência',
    value: 'qtde_separacao',
    numero: true,
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Pedidos em transferência',
    value: 'ids_pedidos_separacao',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Existe similaridade agregada com outro produto',
    value: 'existe_similar',
    style: {
      whiteSpace: 'nowrap'
    }
  },
  {
    text: 'Similares',
    value: 'ids_produtos_similares',
    style: {
      whiteSpace: 'nowrap'
    }
  },
];
